import { render } from "./categorySearch.vue?vue&type=template&id=1ccb0465"
import script from "./categorySearch.vue?vue&type=script&lang=js"
export * from "./categorySearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__